import script from "./Dfsv.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dfsv.vue?vue&type=script&lang=ts&setup=true"

import "./Dfsv.vue?vue&type=style&index=0&id=2b1b3b3e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1b3b3e"]])

export default __exports__